<template>
  <div class="main">
    <DetailsMenu :company="company" title="Company Details" current="Details" />

    <div class="row no-gutters py-4">
      <div class="col-12 col-xxl-4 mb-5 mb-xxl-0">
        <div class="px-3 pl-xxl-4">
          <DetailsPane
            :company="company"
            :hide-close="true"
            :hide-details-button="true"
            :show-full-details="true"
          />
        </div>
      </div>
      <div class="col-12 col-xxl-8">
        <div class="row no-gutters px-3 pr-xxl-4">
          <div class="col-12 text-center col-sm-6 text-sm-left col-lg-9">
            <h4 class="text-uppercase mt-sm-2">Users in this Company</h4>
          </div>
          <div class="col-12 text-center mb-4 col-sm-6 text-sm-right col-lg-3">
            <Field
              type="select"
              name="status_filter"
              v-model="selectedUserStatus"
              :options="statusOptions"
            />
          </div>
          <div class="col-12">
            <ListTable
              :items="items"
              :columns="columns"
              :activeColumns="activeColumns"
              :swappableColumns="false"
              :hideNoResults="hideNoResults"
              @sort-by="setSort"
              @swap-column="setActiveColumn"
            >
              <template v-slot:list-card="{ item, id }">
                <UserCard :item="item" :id="id" :eventBus="listEvents">
                  <UserMenu
                    slot="menu"
                    :item="item"
                    :id="id"
                    :eventBus="listEvents"
                    class="card-menu"
                  />
                </UserCard>
              </template>
              <template v-slot:list-menu="{ item, id }">
                <UserMenu :item="item" :id="id" :eventBus="listEvents" />
              </template>
            </ListTable>
          </div>
          <div class="d-none d-lg-flex col-lg-3"></div>
          <div class="col-12 text-center mb-3 col-lg-6 mb-lg-0">
            <Pagination
              class="d-inline-block"
              :total="totalPages"
              :value="parseInt(pagination.current)"
              @input="setCurrentPage"
            />
          </div>
          <div class="col-12 text-center col-lg-3 text-lg-right">
            <PageSize
              :value="parseInt(pagination.per_page)"
              @input="setPerPage"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ListingMixin from "mixins/Listing";
import DetailsMenu from "./partials/DetailsMenu";
import DetailsPane from "components/partials/Companies/DetailsPane";
import UserCard from "components/partials/Users/ListCard";
import UserMenu from "components/partials/Companies/UserMenu";

export default {
  mixins: [ListingMixin],
  components: { DetailsMenu, DetailsPane, UserCard, UserMenu },
  props: {
    company: { type: Object, required: true },
  },
  data() {
    return {
      selectedUserStatus: "active",
    };
  },
  computed: {
    statusOptions() {
      return [
        { label: "Active", value: "active" },
        { label: "Inactive", value: "inactive" },
        { label: "View All", value: "all" },
      ];
    },
  },
  watch: {
    selectedUserStatus(val) {
      if (val == "all") {
        this.clearFilter("status");
      } else {
        var status = val == "inactive" ? 0 : 1;
        this.replaceFilter("status", status);
      }
    },
  },
};
</script>